import { render, staticRenderFns } from "./FlashSale.vue?vue&type=template&id=23880af9&"
import script from "./FlashSale.vue?vue&type=script&lang=ts&"
export * from "./FlashSale.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports